<form [formGroup]="formGroup" class="autocomplete">
  <div class="field__group field__group--icon-right">
    <input
      type="text"
      #inputAutocomplete
      class="autocomplete__input field__input"
      [ngClass]="{
        'field__input--sm': size === 'small',
        'field__input--lg': size === 'large'
      }"
      *ngIf="formGroup"
      placeholder="{{ placeholder | translate }}"
      aria-label=""
      matInput
      [formControlName]="controlName"
      [matAutocomplete]="auto"
      (click)="clearInput()"
    />
    <mat-autocomplete
      #auto="matAutocomplete"
      [displayWith]="displayName"
      (optionSelected)="optionSelected($event)"
    >
      <mat-option *ngFor="let item of filteredItems" [value]="item">
        <div class="autocomplete__option">
          <span>{{ item.title }}</span>
          <small class="autocomplete__subtitle" *ngIf="item.subtitle">{{
            item.subtitle
          }}</small>
        </div>
      </mat-option>
    </mat-autocomplete>
    <fa-icon *ngIf="!hideSearchIcon" [icon]="searchIcon"></fa-icon>
  </div>
</form>
